import { app } from '@/main'
import base64 from 'hi-base64'

//深層複製資料
export const deepCopy = object => {
  let info = ''
  !!object && (info = JSON.parse(JSON.stringify(object)))
  return info
}

// 是否空陣列
export const isEmptyObject = obj => {
  return Object.keys(obj).length === 0 && obj.constructor === Object
}

// 用value找object key
export const getObjectKey = (obj, val) =>
  Object.keys(obj).find(key => obj[key] === val)

//動態替換 url
export const urlReplace = (url, obj) => {
  let checkUrl = typeof url === 'string' && url.length !== 0
  let checkObj =
    typeof obj === 'object' &&
    !Array.isArray(obj) &&
    Object.keys(obj).length !== 0
  // console.log("fff", url, obj, checkUrl, checkObj);
  if (checkUrl && checkObj) {
    Object.keys(obj).forEach(i => {
      let regExp = new RegExp(`{${i}}`, 'g')
      let replaceText = obj[i]
      url = url.replace(regExp, replaceText)
    })
    return url
  } else {
    console.error('格式有誤，請自行確認')
  }
}

/*
轉換ant design vue的this.form.setFields所需格式
使用情境：後端欄位檢核呈現
欄位說明：
key-預呈現錯誤訊息的欄位名稱
value-預呈現錯誤訊息的欄位當前值
*/
export const validateObj = (key, value) => {
  if (key && value) {
    let obj = {}
    obj[key] = {}
    obj[key]['value'] = value[key]
    obj[key]['errors'] = [
      {
        message: app.$t(`error_${key}_prompt`),
        field: `${key}`
      }
    ]
    // console.log("ddd", key, value, obj);
    return obj
  } else {
    console.error('轉換 this.form.setFields 的格式錯誤，請確認有設定相關的數值')
  }
}

//使用情境、功能同上(validateObj)，可自訂 message
export const validateObjMessage = (key, value, message) => {
  if (key && value && message) {
    let obj = {}
    obj[key] = {}
    obj[key]['value'] = value[key]
    obj[key]['errors'] = [
      {
        message,
        field: `${key}`
      }
    ]
    return obj
  } else {
    console.error('轉換 this.form.setFields 的格式錯誤，請確認有設定相關的數值')
  }
}

//取當前時區(提供isLocal切換是否顯示當地時區，預設true，false則顯示+8時區)
export const getTimezone = (isLocal = true) => {
  return isLocal ? -(new Date().getTimezoneOffset() / 60) : 8
}

//加密規則
export const encode = value => {
  return base64.encode(encodeURIComponent(JSON.stringify(value)))
}

//解密規則
export const decode = value => {
  return JSON.parse(decodeURIComponent(base64.decode(value)))
}

//localstorage list(global)
export const storageList = {
  access_token: 'access_token',
  refresh_token: 'refresh_token',
  callBackName: 'callBackName',
  callBackUrl: 'callBackUrl',
  check_data: 'check_data',
  tokenType: 'tokenType',
  me_info: 'me_info',
  menu: 'menu',
  permission: 'permission',
  lang: 'lang',
  callback_timestamp: 'callback_timestamp'
}

//vue-localstorage(set)
export const setStorage = (key, value) => {
  let list = storageList
  if (key && (value || typeof value === 'boolean') && list[key]) {
    localStorage.setItem(list[key], encode(value))
  } else {
    console.error('儲存 localstorage 的格式錯誤，請確認有設定相關的數值')
  }
}

//vue-localstorage(get)
export const getStorage = key => {
  let list = storageList
  if (key && list[key]) {
    let value = localStorage.getItem(list[key])
    return value ? decode(value) : ''
  } else {
    console.error('讀取 localstorage 的格式錯誤，請確認有設定欲讀取的key值')
  }
}

//vue-localstorage(remove)
export const removeStorage = key => {
  let list = storageList
  if (key && list[key]) {
    localStorage.removeItem(key)
  } else {
    console.error('欲刪除的 localstorage 格式有誤，請確認key值')
  }
}

//vue-localstorage(remove all)
export const removeAllStorage = () => {
  let list = Object.keys(storageList)
  list.forEach(i => {
    localStorage.removeItem(i)
  })
}

export const setDefaultRefreshData = payload => {
  const expiredTimestamp = new Date().getTime() + payload.expiredIn * 1000 // accessToken過期時間
  const waringTimestamp = expiredTimestamp - (payload.expiredIn / 3) * 1000 // 警告時間
  // const waringTimestamp = new Date().getTime() + 3 * 1000 // 測試用
  const expiredTime = new Date(expiredTimestamp).toString()
  const warningTime = new Date(waringTimestamp).toString()
  let checkData = {
    refreshToken: payload.refreshToken,
    expiredIn: payload.expiredIn, // 總時長
    expiredTimestamp,
    waringTimestamp,
    expiredTime,
    warningTime
  }
  setStorage('check_data', checkData)
}

// 判別date是否為底層初始值
export const isValidDate = date => {
  return moment(new Date(date)).isAfter(
    moment(new Date('1970-01-01T00:00:00Z'))
  )
}

/**
 * 針對金額與費率作轉換
 * 符點數加減乘除
 */
// 加法
export const accAdd = (arg1, arg2) => {
  let r1 = null,
    r2 = null,
    c = null
  // 得知小數點後幾位 沒有的話為0
  try {
    r1 = arg1.toString().split('.')[1].length
  } catch (e) {
    r1 = 0
  }
  try {
    r2 = arg2.toString().split('.')[1].length
  } catch (e) {
    r2 = 0
  }

  c = Math.abs(r1 - r2) // 返回絕對值 判斷是否都是整數  都是整數下 0 - 0 = 0

  if (c > 0) {
    // 有小數點的情況
    var cm = Math.pow(10, c)
    if (r1 > r2) {
      arg1 = Number(arg1.toString().replace('.', ''))
      arg2 = Number(arg2.toString().replace('.', '')) * cm
    } else {
      arg1 = Number(arg1.toString().replace('.', '')) * cm
      arg2 = Number(arg2.toString().replace('.', ''))
    }
  } else {
    // 都沒有小數點的情況
    arg1 = Number(arg1.toString().replace('.', ''))
    arg2 = Number(arg2.toString().replace('.', ''))
  }
  // return (arg1 + arg2) / m; // 返回小數點相加結果
  return arg1 + arg2
}

// 減法
export const accSub = (arg1, arg2) => {
  var r1, r2, m, n
  try {
    r1 = arg1.toString().split('.')[1].length
  } catch (e) {
    r1 = 0
  }
  try {
    r2 = arg2.toString().split('.')[1].length
  } catch (e) {
    r2 = 0
  }
  m = Math.pow(10, Math.max(r1, r2)) //last modify by deeka //動態控制精度長度
  n = r1 >= r2 ? r1 : r2
  return ((arg1 * m - arg2 * m) / m).toFixed(n)
}

//乘法
export const accMul = (arg1, arg2 = 100) => {
  var m = 0,
    s1 = arg1.toString(),
    s2 = arg2.toString()
  try {
    m += s1.split('.')[1].length
  } catch (e) {
    console.log('e:', e)
  }
  try {
    m += s2.split('.')[1].length
  } catch (e) {
    console.log('e:', e)
  }
  return (
    (Number(s1.replace('.', '')) * Number(s2.replace('.', ''))) /
    Math.pow(10, m)
  )
}

//除法
export const accDiv = (arg1, arg2 = 100) => {
  var t1 = 0,
    t2 = 0,
    r1,
    r2
  try {
    t1 = arg1.toString().split('.')[1].length
  } catch (e) {
    console.log('e:', e)
  }
  try {
    t2 = arg2.toString().split('.')[1].length
  } catch (e) {
    console.log('e:', e)
  }
  // with (Math) {
  r1 = Number(arg1.toString().replace('.', ''))
  r2 = Number(arg2.toString().replace('.', ''))
  return (r1 / r2) * Math.pow(10, t2 - t1)
  // }
}

/*
 *  CNZZ Event
 * 參考：https://open.cnzz.com/a/api/trackevent/
 * */
export const cnzzEvent = (
  category,
  action,
  label = '',
  value = '',
  nodeid = ''
) => {
  if (!category || !action) {
    return
  }
  window._czc &&
    window._czc.push(['_trackEvent', category, action, label, value, nodeid])
}

export const formItemLayout = {
  labelCol: {
    md: { span: 7 },
    lg: { span: 5 },
    xl: { span: 5 }
  },
  wrapperCol: {
    md: { span: 17 },
    lg: { span: 19 },
    xl: { span: 19 }
  }
}

export const childFormItemLayout = {
  labelCol: {
    md: { span: 6 },
    lg: { span: 4 },
    xl: { span: 3 },
    xxl: { span: 2 }
  },
  wrapperCol: {
    md: { span: 18 },
    lg: { span: 20 },
    xl: { span: 21 },
    xxl: { span: 22 }
  }
}

// Form Model 驗證觸發的時機
export function getFormModelRule(callback, trigger = 'blur') {
  return callback().rules.map(rule => ({
    ...rule,
    trigger
  }))
}

// 刪除沒有值的 obj value
export const clean = obj => {
  for (var propName in obj) {
    if (obj[propName] === null || obj[propName] === '') {
      delete obj[propName]
    }
  }
  return obj
}

export const aryToObj = (key, ary, otherObj) => {
  const payload = {}
  ary.forEach(row => {
    payload[row[key]] = { ...row, ...otherObj }
  })
  return payload
}

export function getDiffItem(prev = [], next = []) {
  const data = { append: [], remove: [] }
  if (!Array.isArray(prev)) {
    console.error('prev is not array')
    return
  }
  if (!Array.isArray(next)) {
    console.error('next is not array')
    return
  }
  prev.forEach(item => {
    if (!next.includes(item)) {
      data.remove.push(item)
    }
  })
  next.forEach(item => {
    if (!prev.includes(item)) {
      data.append.push(item)
    }
  })

  return data
}
